import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import { injectIntl } from "react-intl";
import { fetchNewsletters, newsletterCalenderYearChanged } from "actions/newsletterActions";
import Newsletter from "./Newsletter";
import { Card, Button, Loader } from "cxa-components";
import messages from "components/messagesDescription";
import Select from "react-select";

const Newsletters = ({ intl }) => {
  const newsletters = useSelector(state => state.newsletters);
  const dispatch = useDispatch();
  useEffect(() => {
    newsletters.params.page === 0 && dispatch(fetchNewsletters());
  }, []);

  const onPlanYearChanged = data => {
    dispatch(newsletterCalenderYearChanged());
    dispatch(fetchNewsletters(data.value));
  };

  const loadMoreNewsletter = () => {
    !newsletters.isFetching && dispatch(fetchNewsletters(activePlanYear.year, newsletters.params));
  };

  if (newsletters.isFetching) {
    return <Loader />;
  }
  const activePlanYear =
    newsletters.planYears.find(x => x.isSelected) || newsletters.planYears.find(x => x.isDefault);
  const planYears = newsletters.planYears.map(item => ({ value: item.year, label: item.year }));
  return (
    <div className="apl-library__wrapper">
      <Card>
        <div style={{ display: "grid", gridTemplateColumns: "130px 150px" }}>
          <div style={{ lineHeight: "50px" }}>
            {intl.formatMessage(messages.calendarYearDescription)}
          </div>
          <div>
            <Select
              value={activePlanYear && activePlanYear.year}
              onChange={onPlanYearChanged}
              isClearable={false}
              options={planYears}
            ></Select>
          </div>
        </div>
      </Card>
      <p>
        {intl.formatMessage(messages.showResultsDescription, {
          value0: newsletters.data.length,
        })}
      </p>
      <div className="cxa-grid__wrapper apl-showcase">
        {newsletters.data.map(item => {
          return <Newsletter key={item.key} item={item} />;
        })}
      </div>
      {newsletters.hasMore && (
        <Button Primary onClick={loadMoreNewsletter}>
          {intl.formatMessage(messages.loadMoreDescription)}
        </Button>
      )}
    </div>
  );
};
Newsletters.propTypes = {
  newsletterList: PropTypes.array.isRequired,
  fetchNewsletters: PropTypes.func.isRequired,
  intl: PropTypes.object,
  isFetching: PropTypes.bool,
};

export default injectIntl(Newsletters);



// WEBPACK FOOTER //
// ./components/wellness/Newsletters.jsx